import * as types from '../types'
import { dayMill, statusChange } from '@/utils';
const init = {
    pageNo: 1,
    end: false,
    list: [
        
    ]
}

const past = (state = init, action) => {
    switch(action.type) {
        case types.PAST_HANDLE: {
            const {
                data: {
                    list,
                    pageBean,
                    timer
                }
            } = action;
            
            const newState = {...state}
            newState.list = newState.list.concat(list);
            newState.pageNo++;
            newState.end = pageBean.end;
            const time = timer || new Date().getTime();
            newState.list.map((it, idx) => {
                 //it.status = 0;
                //it.taskEndTime = 1617865347000;
                // it.frozenTime = 20
                // it.rewardDeadline = 10
                
                it.page = 'past';
                const { 
                    mask, 
                    listText, 
                    listSty, 
                    listCls,
                    rewardStartTime,
                    rewardEndTime,
                    showTime,
                    homeTitleText,
                    pastBtnCls
                } = statusChange(it, time);
                it.rewardStartTime = rewardStartTime;
                //领奖结束时间
                it.rewardEndTime = rewardEndTime;
                it.rewardEndTimeText = `${new Date(it.rewardEndTime).format('yyyy.M.d')}前`
                
                it.realStatus = mask;
                it.btnText = listText;
                it.btnSty = listSty; 
                it.btnCls = pastBtnCls;
                const rate = ((it.accrue / it.reachNumber)*100).toFixed(2);
                it.rate = rate > 100?Number(100).toFixed(2): rate;
                it.showTime = showTime;
                it.isOverTitle = showTime > rewardEndTime? '任务已结束': `${it.reachTitle || ''} 领${it.rewardName || ''}`;
                it.homeTitleText = homeTitleText;
            })
            return newState;
        };
        default:
            return state;
    }
}


export default past;